"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a contact could not be found
 * @param {string} field the field that failed validation
 * @param {string} email the email of the contact that was not found
 */
class ContactDoesNotExistError extends client_library_1.ExtendableError {
    constructor(field, email) {
        super(`contact: not found with ${field} ${email}.`);
    }
}
exports.default = ContactDoesNotExistError;
//# sourceMappingURL=ContactDoesNotExistError.js.map